var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"aside",class:{'aside-notactive' : !_vm.asideActive,'aside-active' : _vm.asideActive},attrs:{"id":"app-aside"}})
}
var staticRenderFns = []

export { render, staticRenderFns }